module.exports = __webpack_public_path__ + "img/Ananas_comosus.8750ef61.jpg";